import {useSocket} from "../../../helpers/socket";
import Live2MTWrapper from "./Live2MTWrapper";

const MainMTWrapper = ({config}) => {
    const getResultPlf = config.type === "vnone" ? "mc" : config.type;
    const {socket} = useSocket({platform: `${getResultPlf}_website`})
    return <Live2MTWrapper socket={socket} config={config}/>
}

export default MainMTWrapper;